import { gsap } from './gsap';

const highlight = () => {
  const highlights = document.querySelectorAll('.highlight, .highlight-text em');
  if (highlights.length > 0) {
    highlights.forEach((text) => {
      gsap.to(text, {
        delay: 0.5,
        '--highlight-width': '100%',
        scrollTrigger: {
          trigger: text,
          start: '70% bottom',
          toggleActions: 'play none none reset'
        }
      });
    });
  }
};

export default highlight;
